import { ParkingSessionTimeSlice } from './parking-session-time-slice';

export class ParkingSessionTimeSliceCollection extends Array<ParkingSessionTimeSlice>
{
  public hasCollisionWith(otherCollection: ParkingSessionTimeSliceCollection): boolean
  {
    const itemWithCollision = this.find((t) => {
      const collidingWith = otherCollection.find((tOther) => {
        return t.timeRange.doRangesCover(tOther.timeRange);
      });
      return !!collidingWith;
    });
    return !!itemWithCollision;
  }
}
